import React, { useEffect, useState } from "react";
import { ClientType, selectClientState } from "../../store/slices/clientsSlice";
import useCustomStyles from "../../hooks/useCustomStyles";
import { useDispatch, useSelector } from "react-redux";
import { selectState } from "../../store/slices/themeSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../../store/store";
import { customStyles } from "../../assets/styles/customStyles";
import CustomButton from "../../components/CustomButton";
import { activeClientInfoStyles } from "../../assets/styles/ClientsStyles/activeClientInfoStyles";
import HeaderTabs from "../clients/components/HeaderTabs";
import {
  ErrorTriage,
  ErrorTriageUser,
  getErrorTriageUser,
  updateErrorTriage,
  UpdateErrorTriageParams,
  updateErrorTriageUser,
  UpdateErrorTriageUserParams,
} from "../../api/awsApis";
import TableComponent from "../clients/components/fff";
import DataInput from "../financialInstitutions/components/DataInput";
import LabeledDropdown from "../financialInstitutions/components/LabeledDropdown";
import { string } from "yup";
import { accessCodesStyles } from "../../assets/styles/accessCodesStyles";
import { formatDate } from "../../utils";
import { toast } from "react-toastify";

const ErrorsScreenDetails: React.FC = () => {
  const { theme } = useSelector(selectState);
  const dispatch = useDispatch<AppDispatch>();
  const classes = useCustomStyles(activeClientInfoStyles, theme);

  const classes1 = useCustomStyles(customStyles, theme);
  const classes2 = useCustomStyles(accessCodesStyles, theme);
  const [selectedTab, setSelectedTab] = useState("errorDetails"); // Default to pending
  const location = useLocation();
  const [errorsData, setErrors] = useState(
    location.state?.error as ErrorTriage
  );
  const { clients } = useSelector((state: RootState) => state.clients_slice);
  // const clients = useSelector((state: any) => state.clients.list); // adjust path to match your slice
  const [errorUserTriage, setErrorUserTriage] = useState<ErrorTriageUser[]>([]);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const getpriority = (item: number) => {
    switch (item) {
      case 1:
        return "Low";
      case 2:
        return "Medium";
      case 3:
        return "Hight";
    }
  };
  const tabs = [
    { value: "errorDetails", label: "Error Details" },
    { value: "affectedUsers", label: "Affected Users" },
    { value: "notes", label: "Notes" },
  ];
  const errorTriageColumns = [
    { key: "userName", label: "User Name" },

    { key: "userId", label: "User ID" },

    { key: "firstSeen", label: "First Seen" },
    { key: "lastSeen", label: "Last Seen" },
    { key: "occurrences", label: "Occurrences" },
    { key: "status", label: "Status" },
  ];

  // useEffect(() => {
  //   const fetchErrorTriageData = async () => {
  //     try {
  //       const data = await getErrorTriageUser(errorsData.id);
  //       setErrorUserTriage(data);
  //     } catch (err) {
  //       console.error("Failed to fetch error triage data:", err);
  //     }
  //   };

  //   fetchErrorTriageData();
  // }, [errorsData.id]);
  useEffect(() => {
    const fetchErrorTriageData = async () => {
      try {
        const data = await getErrorTriageUser(errorsData.id);

        // Ensure it's always an array
        setErrorUserTriage(Array.isArray(data) ? data : []);
        console.log(data);
        // setErrorUserTriage(data);
      } catch (err) {
        console.error("Failed to fetch error triage data:", err);
        setErrorUserTriage([]); // fallback to empty array
      }
    };

    fetchErrorTriageData();
  }, [errorsData.id]);

  const formattedErrorTriageUsers = errorUserTriage.map((user) => ({
    ...user,
    // Add userName if you have user data (or generate mock user names)
    userName: (user.user && user.user.name) ?? "", // Example: "User 123"
    // firstSeenFormatted: formatDate(user.firstSeen),
    // lastSeenFormatted: formatDate(user.lastSeen),
    // Or if you want to keep the original but use formatted for display:
    firstSeen: formatDate(user.firstSeen),
    lastSeen: formatDate(user.lastSeen),
  }));

  const [note, setNote] = useState("");

  const handleNoteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    console.log(note);
    setNote(e.target.value);
  };

  // Find the clicked client by userId
  const handleRowClick = (rowData: any) => {
    const selectedClient = clients?.find(
      (c: ClientType) => c.app_user_id === rowData.userId
    );

    console.log("Row pressed:", rowData);
    // You can now access all the data from the clicked row
    console.log("User ID:", rowData.userId);
    console.log("User Name:", rowData.userName);
    console.log("Status:", rowData.status);
    console.log("Occurrences:", rowData.occurrences);
    console.log("selectedClient", selectedClient);
    // setErrorTrige(rowData);
    // Only navigate if selectedClient exists
    if (!selectedClient) {
      console.warn("Selected client not found");
      // Handle the error case (show toast, alert, etc.)
      return;
    }

    navigate(`/clientDetails`, {
      state: {
        client: selectedClient,
        selectedTab: "error-log",
      },
    });
  };
  let rows: { label: string; value: string | Date | number | undefined }[] = [];
  if (selectedTab === "errorDetails") {
    rows = [
      { label: "Error Code", value: errorsData.errorCode },
      { label: "Error Message", value: errorsData.errorMessage },
      { label: "ID", value: errorsData.id },
      { label: "Process ID", value: errorsData.processId },
      { label: "Application", value: errorsData.application },
      { label: "System/Provider", value: errorsData.errorWith },
      { label: "API", value: errorsData.errorApi },
      // { label: "First Seen", value: errorsData.firstSeen },
      // // { label: "App Version", value: errorsData.versionIntroduced },
      // { label: "Last Seen", value: errorsData.lastSeen },
      {
        label: "First Seen",
        value: errorsData.firstSeen ? errorsData.firstSeen : undefined,
      },
      {
        label: "Last Seen",
        value: errorsData.lastSeen ? errorsData.lastSeen : undefined,
      },

      { label: "Occurrences", value: errorsData.occurrences },
      { label: "Affected Users", value: errorsData.affectedUsersCount },
    ];
  }
  const [editedData, setEditedData] = useState<UpdateErrorTriageParams>({
    status: errorsData.status,
    priority: errorsData.priority,
    notes: note ?? "",
  });

  const handleUpdateError = async (data: UpdateErrorTriageParams) => {
    try {
      setLoading(true);

      console.log("Updating with data:", editedData);
      const { status, priority, notes } = data;
      // Filter out unchanged fields to avoid unnecessary updates
      const updatePayload: UpdateErrorTriageParams = {};

      if (status !== errorsData.status) {
        updatePayload.status = status;
      }

      if (priority !== errorsData.priority) {
        updatePayload.priority = priority;
      }

      if (notes !== (note ?? "")) {
        updatePayload.notes = notes;
      }

      // Only call API if there are changes
      if (Object.keys(updatePayload).length > 0) {
        const result = await updateErrorTriage(errorsData.id, updatePayload);
        setLoading(false);
        console.log("Update successful:", result);

        toast.success("Update successful!");
      } else {
        setLoading(false);

        console.log("No changes to save.");
      }
    } catch (error) {
      setLoading(false);

      console.error("Failed to update error triage:", error);
      toast.error("Failed to update error triage");
    }
  };

  // Define status options
  const statusOptions = [
    { value: "OPEN", label: "OPEN" },
    { value: "IN_PROGRESS", label: "IN PROGRESS" },
    { value: "RESOLVED", label: "RESOLVED" },
  ];
  // Handle status change
  const handleStatusChange = async (rowData: any, newStatus: string) => {
    try {
      // Prepare update data
      const updateData: UpdateErrorTriageUserParams = {
        status: newStatus,
        notes: `Status changed to ${newStatus}`, // Optional: add a note
      };

      // Call the update function
      const response = await updateErrorTriageUser(rowData.id, updateData);

      console.log("Status updated successfully:", response);

      // Update local state optimistically
      setErrorUserTriage((prev) =>
        prev.map((item) =>
          item.id === rowData.id ? { ...item, status: newStatus } : item
        )
      );
      toast.success("Update successful!");
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };
  return (
    <div className={classes2.container}>
      <div className={classes2?.box}>
        <div className={classes2.tableContainer}>
          <h2 className={classes2.header}>ERROR DETAILS</h2>
        </div>
      </div>

      <>
        <HeaderTabs
          tabs={tabs}
          selectedTab={selectedTab}
          onSelect={setSelectedTab}
        />
        {selectedTab === "errorDetails" ? (
          <div className={classes.innerContainer}>
            <div
              style={{
                // padding: "0px 10px",
                padding: 0,

                minWidth: "50px",
                maxWidth: "100%",
                display: "flex",
                flexDirection: "row",
                overflowX: "auto",
              }}
            >
              <table className={classes.table}>
                <tbody>
                  {rows.map((row, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 1 ? "#fff" : " #F6F6F6", // White for even, red for odd
                        // borderBottom: "1px solid #eee",
                        maxHeight: "10",
                      }}
                    >
                      <td className={classes.labelCell}>{row.label}</td>
                      {/* <td className={classes.valueCell}>{row.value}</td> */}
                      <td className={classes.valueCell}>
                        {row.value instanceof Date
                          ? row.value.toLocaleString()
                          : row.value ?? "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div
              style={{
                display: "flex",
                // gap: "12px",
                justifyContent: "space-between",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <LabeledDropdown
                isGrouped
                label="Status"
                options={[
                  { key: "1", displayName: "Open", value: "OPEN" },
                  {
                    key: "2",
                    displayName: "In Progress",
                    value: "IN_PROGRESS",
                  },
                  { key: "3", displayName: "Re Solved", value: "RESOLVED" },
                ]}
                initialState={errorsData.status}
                handleSelect={(value) => {
                  setEditedData((prev) => ({
                    ...prev,
                    status: value as string,
                  }));
                }}
              />
              <LabeledDropdown
                isGrouped
                label="Priority"
                options={[
                  { key: "1", displayName: "High", value: 1 },
                  { key: "2", displayName: "Medium", value: 2 },
                  { key: "3", displayName: "Low", value: 3 },
                ]}
                initialState={errorsData.priority}
                handleSelect={(value) => {
                  setEditedData((prev) => ({
                    ...prev,
                    priority: value as number,
                  }));
                }}
              />
              <div style={{ width: "50%" }}>
                <CustomButton
                  title={"Save changes"}
                  handleClick={() => handleUpdateError(editedData)}
                  name={"save-changes"}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        ) : selectedTab === "affectedUsers" ? (
          <>
            <div className={classes.innerContainer}>
              <TableComponent
                columns={errorTriageColumns}
                data={formattedErrorTriageUsers}
                onRowClick={handleRowClick}
                pagination={true}
                itemsPerPage={10}
                dropdownStatus={[
                  {
                    key: "status",
                    options: statusOptions,
                    onChange: handleStatusChange,
                  },
                ]}
              />
            </div>
          </>
        ) : (
          <>
            <div className={classes.innerContainer}>
              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  Notes
                </label>
                <textarea
                  value={editedData.notes ?? ""}
                  name="note"
                  onChange={(e) =>
                    setEditedData((prev) => ({
                      ...prev,
                      notes: e.target.value,
                    }))
                  }
                  placeholder="Add notes here..."
                  style={{
                    width: "100%",
                    minHeight: "100px",
                    padding: "12px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "14px",
                    fontFamily: "inherit",
                    resize: "vertical",
                    boxSizing: "border-box",
                  }}
                />
                {/* <textarea name="note" placeholder="Add notes here..." /> */}
              </div>
              <div
                style={{
                  width: "25%",
                }}
              >
                <CustomButton
                  title={"Save Changes"}
                  handleClick={() => handleUpdateError(editedData)}
                  name={"add-advisor"}
                  loading={loading}
                />
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
};

export default ErrorsScreenDetails;
